import React from 'react';

const TRANSPARENT_PIXEL =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';

const markImageAsFailed = (image) => {
  if (!image || image.dataset.agsusImageFallback === 'true') return;

  const rect = image.getBoundingClientRect();
  image.dataset.agsusImageFallback = 'true';
  image.dataset.agsusOriginalSrc = image.currentSrc || image.src || '';
  image.classList.add('agsus-image-fallback');

  if (rect.width >= 24) {
    image.style.setProperty(
      '--agsus-image-fallback-width',
      `${Math.round(rect.width)}px`,
    );
  }
  if (rect.height >= 24) {
    image.style.setProperty(
      '--agsus-image-fallback-height',
      `${Math.round(rect.height)}px`,
    );
  }

  image.src = TRANSPARENT_PIXEL;
  image.removeAttribute('srcset');
};

const ImageFallback = () => {
  React.useEffect(() => {
    const onError = (event) => {
      if (event.target?.tagName === 'IMG') {
        markImageAsFailed(event.target);
      }
    };

    const checkLoadedImages = () => {
      document.querySelectorAll('img').forEach((image) => {
        if (image.complete && image.naturalWidth === 0) {
          markImageAsFailed(image);
        }
      });
    };

    document.addEventListener('error', onError, true);
    checkLoadedImages();

    const observer = new MutationObserver(checkLoadedImages);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset'],
    });

    return () => {
      document.removeEventListener('error', onError, true);
      observer.disconnect();
    };
  }, []);

  return null;
};

export default ImageFallback;
